export default class BaseModel {
  constructor(data) {
    this.errors = data.errors || {}
    // this.dynamicFieldsOptions = {};
  }

  set_api_errors = (errors) => {
    // super
    for (let field in errors) {
      this.errors[field] = errors[field]
      if (this.errors["base"] !== undefined) {
        this.errors["base"] = errors.base;
      }
    }
  }

  toStateJson = () => {
    return JSON.parse(JSON.stringify(this));
  }

  completeValidation = () => {
    delete this.errors["base"]

    Object.keys(this).forEach((key) => {
      this.validate(key);
    });

    // remove the errors which are from the backend
    Object.keys(this.errors).forEach((key) => {
      if (this.validations(key) === undefined) {
        delete this.errors[key]
      }
    })

    if(this.errors.constructor === Object && Object.keys(this.errors).length !== 0) {
      throw JSON.stringify(this.errors);
    }
  }
}
